import { Link } from "react-router-dom";
import star_icon from "../Assets/star_icon.png";
import star_dull_icon from "../Assets/star_dull_icon.png";
import { motion } from "framer-motion";
import arrow from "../../assets/arrow.png";
import { ShopContext } from "../../Context/ShopContext";
import { useContext } from "react";
import cart from "../../assets/cart.png";

const Item = (props) => {
  const { addToCart } = useContext(ShopContext);
  return (
    <motion.div
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.2 }}
      className="bg-white relative rounded-lg shadow-md flex flex-col justify-between h-full hover:shadow-xl transition duration-300 ease-in-out"
    >
      {!props.available && (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center">
          <div className="text-[#DA0004] top-5 font-bold px-5 py-3 rounded-md uppercase">
            Unavailable
          </div>
        </div>
      )}
      <div className="flex flex-col items-left flex-grow">
        <div className="flex flex-col justify-between flex-grow">
          <div className="flex flex-col">
            <Link
              to={`/product/${props.id}`}
              className="flex justify-center items-center"
            >
              <img
                src={props.image[0]}
                alt={props.name}
                className="w-36 h-36 xs:h-48 xs:w-48 sm:w-44 sm:h-44 md:w-40 md:h-40 lg:w-40 lg:h-40 xl:w-44 xl:h-44 object-cover rounded-md mb-4"
              />
            </Link>
            <h2 className="px-2 text-sm font-semibold leading-tight line-clamp-2">{props.name}</h2>
          </div>
        </div>
      </div>
      <div className="px-2 flex flex-col">
        <h4 className="text-xs font-normal text-gray-500 line-through">
          Price: Rs.{props.old_price}
        </h4>
        <h3 className="text-sm font-bold text-[#DA0004]">
          Rs.{props.new_price}
        </h3>
        <h3 className="text-xs text-gray-500">{props.category}</h3>
        <div className="flex items-center mt-1">
          {props.rating >= 1 ? (
            <img src={star_icon} alt="" className="w-3 h-3" />
          ) : (
            <img src={star_dull_icon} alt="" className="w-3 h-3" />
          )}
          {props.rating >= 2 ? (
            <img src={star_icon} alt="" className="w-3 h-3" />
          ) : (
            <img src={star_dull_icon} alt="" className="w-3 h-3" />
          )}
          {props.rating >= 3 ? (
            <img src={star_icon} alt="" className="w-3 h-3" />
          ) : (
            <img src={star_dull_icon} alt="" className="w-3 h-3" />
          )}
          {props.rating >= 4 ? (
            <img src={star_icon} alt="" className="w-3 h-3" />
          ) : (
            <img src={star_dull_icon} alt="" className="w-3 h-3" />
          )}
          {props.rating >= 5 ? (
            <img src={star_icon} alt="" className="w-3 h-3" />
          ) : (
            <img src={star_dull_icon} alt="" className="w-3 h-3" />
          )}
          <p className="ml-2 text-xs">({props.no_of_rators})</p>
        </div>
      </div>
      <div className="flex justify-start mt-2 px-2 pb-2">
        {/* <Link to={`/product/${props.id}`} className="bg-[#E6B17E] text-[#551e19] px-2 py-1 text-sm rounded-xl hover:bg-[#c98c3c] flex items-center font-oswald">
          View Product <img src={arrow} className="ml-2 h-4 w-4" />
        </Link> */}
        <button
          onClick={() => addToCart(props.id, 1)}
          className="text-[#DA0004] text-xs rounded-xl flex items-center text-start font-medium uppercase"
        >
          Add to Cart{" "}
          <img src={cart} alt="cart-icon" className="ml-2 h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
};

export default Item;
